module.exports = __webpack_public_path__ + "img/pageTurning.b49820ea.gif";